import Chronometer from 'app/components/Chronometer'
import DodoneEditModal from 'app/dodones/edit/Modal'

export default ({ dodone, onTick, start = null }) => {
  const hasChildren = dodone.children.length > 0
  const attributesNames = useMemo(() => {
    const base = ['started_At']

    if (dodone.isTimeout) base.push('timeout')

    return base
  }, [dodone])

  return (
    <DodoneEditModal attributesNames={attributesNames}>
      <Chronometer
        startedAt={start || dodone.startedAt}
        size={hasChildren ? 'small' : 'big'}
        onTick={onTick}
        timeout={dodone.timeout}
      />
    </DodoneEditModal>
  )
}
